import styled from '@emotion/styled'

export const AuthContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: ${props => props.theme.colors.whisper};
  width: 100%;
`

export const AuthInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-bottom: ${({ mb }) => mb || '1rem'};
`

export const ForgotPasswordAndRememberCol = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ForgotPassword = styled.p`
  color: ${props => props.theme.colors.linkColor};
`

export const AuthInputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`
